"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTests = void 0;
var event_tests_1 = require("./event-tests");
var EventTests = /** @class */ (function () {
    function EventTests(utils) {
        this.all = function () { return (0, event_tests_1.eventTests)(utils); };
    }
    return EventTests;
}());
exports.EventTests = EventTests;
